module.exports = __webpack_public_path__ + "static/img/w-1.09f98e8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/worldView/w-1.jpg
// module id = XkSq
// module chunks = 1